<div class="project-result__card">
	<a class="project-result__link" :href="url">
		<div v-if="imageUrl" class="project-result__img">
			<img :src="imageUrl" :alt="title">
		</div>
		<div class="project-result__body">
			<span v-html="highlightResults.title.value">{{highlightResults.title.value}}</span>
		</div>
	</a>
</div>
